import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context';
import { WorkspaceProvider } from '@/context';
import { AuthNavigationSync } from '@/components/auth/AuthNavigationSync';
import { ProtectedRoute, LoginRoute } from '@/components/auth/ProtectedRoute';
import { HomeRedirect } from '@/components/auth/HomeRedirect';
import { RootCatchAll } from '@/components/auth/RootCatchAll';
import MainLayout from '@/layouts/MainLayout';
import LoginPage from '@/pages/LoginPage';
import WorkspacePage from '@/pages/WorkspacePage';
import ConversationRoute from '@/pages/ConversationsPage';
import ConversationsListPage from '@/pages/ConversationsPage/ConversationsPage';
import SavedActionsPage from '@/pages/SavedActionsPage';
import SettingsPage from '@/pages/SettingsPage';
import FigmaScreensPage from '@/pages/FigmaScreensPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <AuthNavigationSync />
        <Routes>
          <Route
            path="/login"
            element={
              <LoginRoute>
                <LoginPage />
              </LoginRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <WorkspaceProvider>
                  <MainLayout />
                </WorkspaceProvider>
              </ProtectedRoute>
            }
          >
            <Route index element={<HomeRedirect />} />
            <Route path="workspace" element={<WorkspacePage />} />
            <Route path="user/novice/workspace" element={<WorkspacePage />} />
            <Route path="user/operator/workspace" element={<WorkspacePage />} />
            <Route path="user/novice/conversations" element={<ConversationsListPage />} />
            <Route path="user/novice/conversations/:conversationId" element={<ConversationRoute />} />
            <Route path="user/operator/conversations" element={<ConversationsListPage />} />
            <Route path="user/operator/conversations/:conversationId" element={<ConversationRoute />} />
            <Route path="conversations/:conversationId?" element={<ConversationRoute />} />
            <Route path="saved-actions" element={<SavedActionsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="figma-screens" element={<FigmaScreensPage />} />
          </Route>
          <Route path="*" element={<RootCatchAll />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
